import { compose } from 'lodash/fp'
import EventHint from './EventHint'
import withState from './withState'

export default compose(withState)(EventHint)
